module.exports = __webpack_public_path__ + "img/identity-line.fb01cbcc.svg";